export default (value, label) => {
  return value ? value : label ? label : '-'
}
